/**
 * Licensed Materials - Property of IBM
 * IBM Cognos Products: BI Cloud (C) Copyright IBM Corp. 2013, 2017
 * US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
 */
define([
	'./LayoutBaseView',
	'../../../lib/@waca/core-client/js/core-client/utils/EventHelper'
], function(BaseLayout) {

	var PageCollectionView = null;
	PageCollectionView = BaseLayout.extend({
		init: function() {
			PageCollectionView.inherited('init', this, arguments);
			this._started = true;
		}
	});
	return PageCollectionView;
});